import Header from "@src/components/header/Header";
import { Outlet, useLocation, matchPath, useNavigate } from "react-router-dom";
import "@src/pages/layout/AppLayout.scss";
import BreadCrumbs from "@src/components/breadcrumbs/BreadCrumbs";
import { Toastify, PopUpModal, Typography } from "top-brains-ui";
import { Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@src/app/store";
import { setNavigateWebsite } from "@src/app/globalSlice";
import { isElectronApp } from "@src/utils/envUtils";
import ErrorBoundary from "../page-not-found/ErrorBoundary";
import CommonLoader from "@src/components/loader/CommonLoader";

const AppLayout: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isDashboard = location.pathname === "/dashboard";
  const { navigateWebsite } = useSelector(
    (state: RootState) => state.globalSlice,
  );
  const navigate = useNavigate();

  const isElectron = isElectronApp();

  const noHeaderPaths = [
    "/batches/test/test-screen",
    "/activities/myQuiz/quiz-screen",
    "/activities/quizGroup/quiz-screen",
    "/activities/tournaments/tournament-screen",
    "/activities/tournaments/tournamentResult",
    "/activities/tournaments/tournamentResult/questionDetails",
    "/website-tournaments/tournamentDetails/questionDetails",
    "/organizations/quiz/student-quiz-details",
    ...(isElectron
      ? ["/batches/test/instruction", "/batches/test/details"]
      : []),
  ];

  const hideHeaderContainerPaths = [
    "batch/course-dashboard",
    "course-dashboard",
  ];

  const hideHeaderContainer = hideHeaderContainerPaths.some((pattern) =>
    location.pathname.includes(pattern),
  );

  const isAppHeader =
    noHeaderPaths.some((pattern) =>
      matchPath({ path: pattern, end: true }, location.pathname),
    ) &&
    ![
      "/activities/tournaments/tournamentDetails",
      "/activities/quizGroup/details",
      "/activities/myQuiz/details",
      "/activities/myQuiz/instruction",
      "/activities/quizGroup/instruction",
      "/activities/quizGroup/quiz",
      "/activities/tournaments/tournament-instruction",
    ].includes(location.pathname) &&
    !(location.pathname === "/batches/test/details" && !isElectron) &&
    !(location.pathname === "/batches/test/instruction" && !isElectron);

  return isAppHeader ? (
    <div className={`main-layout ${isElectron ? "electronApp" : ""}`}>
      <ErrorBoundary key={location.pathname}>
        <Suspense fallback={<CommonLoader color="var(--primary-color)" />}>
          <Outlet />
        </Suspense>
      </ErrorBoundary>
      <Toastify />
      {navigateWebsite && (
        <PopUpModal
          isOpen={navigateWebsite}
          onContinue={() => {
            dispatch(setNavigateWebsite(false));
            navigate("/");
          }}
          onClose={() => {
            dispatch(setNavigateWebsite(false));
          }}
          colorForTitleMessage="#434db8"
          titleMessage="Confirmation!"
          border="1px solid #434db8"
          subTitleMessage=""
          buttonVariant="primary"
          iconName="info"
          modalMessage={
            <Typography fontSize={16} fontWeight="medium">
              You are trying to move to website. Are you sure want to Continue?
            </Typography>
          }
          secondButtonLabel="Continue"
          firstButtonLabel="Cancel"
          showCloseIcon={false}
        />
      )}
    </div>
  ) : (
    <div className={`main-layout ${isElectron ? "electronApp" : ""}`}>
      <Header />
      <div
        className={`tf-main-container ${hideHeaderContainer ? "hide-header-padding" : ""}`}
      >
        {!hideHeaderContainer && (
          <div className="tf-header-container">
            <div className="breadcrumb-container">
              {!isDashboard && <BreadCrumbs />}
            </div>
          </div>
        )}
        <div className="tf-outlet-container">
          <ErrorBoundary key={location.pathname}>
            <Suspense fallback={<CommonLoader color="var(--primary-color)" />}>
              <Outlet />
            </Suspense>
          </ErrorBoundary>
          <Toastify />
        </div>
      </div>
      {navigateWebsite && (
        <PopUpModal
          isOpen={navigateWebsite}
          onContinue={() => {
            dispatch(setNavigateWebsite(false));
            navigate("/");
          }}
          onClose={() => {
            dispatch(setNavigateWebsite(false));
          }}
          colorForTitleMessage="#434db8"
          titleMessage="Confirmation!"
          border="1px solid #434db8"
          subTitleMessage=""
          buttonVariant="primary"
          iconName="info"
          modalMessage={
            <Typography fontSize={16} fontWeight="medium">
              You are trying to move to website. Are you sure want to Continue?
            </Typography>
          }
          secondButtonLabel="Continue"
          firstButtonLabel="Cancel"
          showCloseIcon={false}
        />
      )}
    </div>
  );
};

export default AppLayout;
